import { eeaDefaultData, eeaCookies } from './gtag.js';
// fab365에서 저장되어 있는 쿠키 값 가져오는 함수
function getCookie(name) {
  let matches = document.cookie.match(
    new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)')
  );
  return matches ? decodeURIComponent(matches[1]) : null;
}

const liveSiteCookie = getCookie('eea_approval');
const adSiteCookies = getCookie('eea_approval');

// 'ad' 쿠키의 값
eeaDefaultData(liveSiteCookie);

!liveSiteCookie && !adSiteCookies && document.querySelector('.popup').classList.remove('hidden');
!liveSiteCookie &&
  !adSiteCookies &&
  document.querySelector('.pop-shadow').classList.remove('hidden');

//모달창 접었다 펴지는 부분

document.querySelectorAll('.arrow-up-btn').forEach(node => {
  node.addEventListener('click', btn => {
    const currentButton = btn.target.closest('button');
    const parentDiv = currentButton.closest('div');
    const relatedParagraph = parentDiv.nextElementSibling;

    if (currentButton.querySelector('img').src.includes('arrow_up.png')) {
      currentButton.querySelector('img').src =
        'https://fab-assets-v2.s3.ap-northeast-2.amazonaws.com/img/landing/ad-landing/cookies/arrow_down.png';
      relatedParagraph.classList.remove('p-none');
    } else {
      currentButton.querySelector('img').src =
        'https://fab-assets-v2.s3.ap-northeast-2.amazonaws.com/img/landing/ad-landing/cookies/arrow_up.png';
      relatedParagraph.classList.add('p-none');
    }
  });
});

//모발창 켜고 닫기
const closeBtn = document.querySelector('.close-btn');
const customize = document.querySelector('#customize-btn');

// class="necessary"
closeBtn.addEventListener('click', () => {
  document.querySelector('.custom-container').classList.add('custom-container-hidden');
  document.querySelector('.custom-box-shadow').classList.add('custom-container-hidden');
  document.querySelector('body').style.overflow = 'visible';
});

customize.addEventListener('click', () => {
  document.querySelector('.custom-container').classList.remove('custom-container-hidden');
  document.querySelector('.custom-box-shadow').classList.remove('custom-container-hidden');
  document.querySelector('body').style.overflow = 'hidden';
});

//쿠키 동의 관련 함수
const acceptAllBtn = document.querySelectorAll('.all-cookies');
const necessaryBtn = document.querySelectorAll('.necessary');
const customizeBtn = document.querySelector('#customize-data');

const performance = document.querySelector('#performance-cookies');
const functional = document.querySelector('#functional-cookies');
const targeting = document.querySelector('#targeting-cookies');
const customCookiesObj = {
  performanceCookies: 'denied',
  functionalCookies: 'denied',
  targetingCookies: 'denied',
};

//커스텀 쿠키 토글 메뉴 이벤트
const checkBockListener = node => {
  node.addEventListener('click', e => {
    if (e.target.id === 'performance-cookies') {
      customCookiesObj.performanceCookies = e.target.checked ? 'granted' : 'denied';
    } else if (e.target.id === 'functional-cookies') {
      customCookiesObj.functionalCookies = e.target.checked ? 'granted' : 'denied';
    } else {
      customCookiesObj.targetingCookies = e.target.checked ? 'granted' : 'denied';
    }
  });
};

checkBockListener(performance);
checkBockListener(functional);
checkBockListener(targeting);

//쿠키전송
acceptAllBtn.forEach(node => {
  node.addEventListener('click', () => {
    const acceptData = {
      ad_storage: 'granted',
      ad_user_data: 'granted',
      ad_personalization: 'granted',
      functionality_storage: 'granted',
      analytics_storage: 'granted',
    };

    cookiesSave(acceptData);
  });
});

necessaryBtn.forEach(node => {
  node.addEventListener('click', () => {
    const necessaryData = {
      ad_user_data: 'granted',
      ad_storage: 'denied',
      ad_personalization: 'denied',
      functionality_storage: 'denied',
      analytics_storage: 'denied',
    };

    cookiesSave(necessaryData);
  });
});

customizeBtn.addEventListener('click', e => {
  const customizeData = {
    ad_user_data: 'granted',
    ad_storage: customCookiesObj.targetingCookies,
    ad_personalization: customCookiesObj.targetingCookies,
    functionality_storage: customCookiesObj.functionalCookies,
    analytics_storage: customCookiesObj.performanceCookies,
  };
  cookiesSave(customizeData);
});

function cookiesSave(data) {
  document.querySelector('body').style.overflow = 'visible';
  const jsonString = JSON.stringify(data);
  const encodedData = encodeURIComponent(jsonString);
  document.cookie = `eea_approval=${encodedData}; domain=.fab365.net; path=/; expires=Tue, 19 Jan 2025 03:14:07 GMT; Secure; SameSite=None`;
  eeaCookies(data);
  document.querySelector('.custom-container').classList.add('custom-container-hidden');
  document.querySelector('.custom-box-shadow').classList.add('custom-container-hidden');
  document.querySelector('.popup').classList.add('hidden');
  document.querySelector('.pop-shadow').classList.add('hidden');
}
